import has from 'lodash/has';
import axios from 'axios';
import * as types from '../constants/ActionTypes';

// Helpers.
import { docTypeOptions } from '../../lib/customFields';
import { trackLink } from '../../lib/analytics-helper';
import Page from '../../lib/page';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const SEARCH_ARTICLE_API_URL = '/smarthelp/related-article';

function requestArticleSearch() {
  return {
    type: types.REQUEST_ARTICLE_SEARCH,
    payload: undefined,
  };
}

function receiveArticleSearchResult(searchTerm, experience, responseData, documentType) {
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_RESPONSE,
    payload: {
      q: searchTerm,
      experience,
      items: responseData,
      channel: documentType,
    },
  };
}

function receiveArticleSearchError(searchTerm, experience, documentType) {
  setTimeout(() => trackLink({ id: 'searchPage', link: 'smarthelp-error-search', srch: `${searchTerm}` }), 1500);
  return {
    type: types.RECEIVE_ARTICLE_SEARCH_ERROR,
    payload: {
      q: searchTerm,
      experience,
      channel: documentType,
    },
  };
}

function fetchArticleSearchResult(searchTerm, experience, channel) {
  const documentType = (has(docTypeOptions, channel)) ? channel : 'faq';
  const trackLinkOption = {
    id: 'searchPage',
    link: `smarthelp-search-filter-document-type|${documentType}`,
    srch: searchTerm,
  };
  const articleSearchUrl = `${SEARCH_ARTICLE_API_URL}?q=${Page.getSanitizedValue(searchTerm)}&exp=${experience}&channel=${documentType}`;

  return (dispatch) => {
    dispatch(requestArticleSearch());
    return axios.get(articleSearchUrl, {
      cancelToken: source.token,
    })
    .then((response) => {
      setTimeout(() => trackLink(trackLinkOption), 1000);
      dispatch(receiveArticleSearchResult(searchTerm, experience, response.data, documentType));
    })
    .catch(() => {
      setTimeout(() => trackLink(trackLinkOption), 1000);
      dispatch(receiveArticleSearchError(searchTerm, experience, documentType));
    });
  };
}

function cancelArticleSearchRequest() {
  source.cancel('Article Search request canceled.');
}

module.exports = {
  fetchArticleSearchResult,
  cancelArticleSearchRequest,
};
